import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    padding: '52px 48px 24px',
  },

  header: {
    color: '#102131',
    fontFamily: '"Manrope", sans-serif',
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '48px',
  },

  btn: {
    width: '45%',
    '@media(max-width: 900px)': {
      width: '100%',
    },
  },
});
